import React, { Dispatch, SetStateAction } from 'react';

import IProduct from '../../../../models/product';
import InputTextField from '../../../inputfields/InputTextField';
import useDebouncedStateString from 'hooks/useDebouncedState';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';

interface ConsumerContactProps {
  isSuperuser?: boolean;
  state: IProduct;
  approve?: boolean;
  setState: Dispatch<SetStateAction<IProduct>>;
  readOnly?: boolean;
}

const ConsumerContact = ({ isSuperuser, state, setState, readOnly, approve }: ConsumerContactProps) => {
  const [consumerContactCompanyName, handleConsumerContactCompanyNameChange] = useDebouncedStateString(
    state.consumerContactCompanyName || '',
    setState,
    'consumerContactCompanyName',
    300
  );

  const [consumerContactPhone, handleConsumerContactPhoneChange] = useDebouncedStateString(
    state.consumerContactPhone || '',
    setState,
    'consumerContactPhone',
    300
  );

  const [consumerContactEmail, handleConsumerContactEmailChange] = useDebouncedStateString(
    state.consumerContactEmail || '',
    setState,
    'consumerContactEmail',
    300
  );

  const [consumerContactWebsite, handleConsumerContactWebsiteChange] = useDebouncedStateString(
    state.consumerContactWebsite || '',
    setState,
    'consumerContactWebsite',
    300
  );

  const [consumerContactAddress, handleConsumerContactAddressChange] = useDebouncedStateString(
    state.consumerContactAddress || '',
    setState,
    'consumerContactAddress',
    300
  );

  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <div style={{ flexGrow: 1 }}>
            <InputTextField<IProduct>
              readOnly={readOnly}
              dense={false}
              withLabel
              inputName="consumerContactCompanyName"
              value={consumerContactCompanyName}
              onChange={e => handleConsumerContactCompanyNameChange(e.target.value)}
              label={readOnly ? undefined : 'Företagsnamn för konsumentkontakt'}
              labelOptions={{
                heading: 'Företagsnamn för konsumentkontakt',
                text: 'Företagsnamn till det ansvariga företaget för konsumentfrågor och klagomål.',
              }}
            />
          </div>

          <div style={{ flexGrow: 1 }}>
            <InputTextField<IProduct>
              readOnly={readOnly}
              dense={false}
              withLabel
              inputName="consumerContactPhone"
              value={consumerContactPhone}
              onChange={e => handleConsumerContactPhoneChange(e.target.value)}
              label={readOnly ? undefined : 'Telefonnummer för konsumentkontakt'}
              labelOptions={{
                heading: 'Telefonnummer för konsumentkontakt',
                text: 'Telefonnummer till det ansvariga företaget där konsumenter kan kontakta vid frågor eller klagomål.',
              }}
            />
          </div>

          <div style={{ flexGrow: 1 }}>
            <InputTextField<IProduct>
              readOnly={readOnly}
              dense={false}
              withLabel
              inputName="consumerContactEmail"
              value={consumerContactEmail}
              onChange={e => handleConsumerContactEmailChange(e.target.value)}
              label={readOnly ? undefined : 'E-post för konsumentkontakt'}
              labelOptions={{
                heading: 'E-post för konsumentkontakt',
                text: 'E-postadress till det ansvariga företaget för konsumentfrågor och klagomål.',
              }}
            />
          </div>

          <div style={{ flexGrow: 1 }}>
            <InputTextField<IProduct>
              readOnly={readOnly}
              dense={false}
              withLabel
              inputName="consumerContactWebsite"
              value={consumerContactWebsite}
              onChange={e => handleConsumerContactWebsiteChange(e.target.value)}
              label={readOnly ? undefined : 'Webbplats för konsumentkontakt'}
              labelOptions={{
                heading: 'Webbplats för konsumentkontakt',
                text: 'Webbadress till det ansvariga företaget för konsumentfrågor och klagomål.',
              }}
            />
          </div>

          <div style={{ flexGrow: 1 }}>
            <InputTextField<IProduct>
              readOnly={readOnly}
              dense={false}
              withLabel
              multiline={true}
              multilineRows={2}
              multilineMax={20}
              inputName="consumerContactAddress"
              value={consumerContactAddress}
              onChange={e => handleConsumerContactAddressChange(e.target.value)}
              label={readOnly ? undefined : 'Adress för konsumentkontakt'}
              labelOptions={{
                heading: 'Adress för konsumentkontakt',
                text: 'Adress till det ansvariga företaget där konsumenter kan vända sig med frågor eller klagomål.',
              }}
            />
          </div>

          {isSuperuser && (
            <FormControlLabel
              disabled={readOnly}
              control={
                <Checkbox
                  size="small"
                  checked={state.exportConsumerContact}
                  onChange={() => setState(state => ({ ...state, exportConsumerContact: !state.exportConsumerContact }))}
                  color="primary"
                />
              }
              label="Använd ovan kontaktuppgifter för konsument vid export"
              style={{ marginLeft: 0 }}
            />
          )}
        </div>
      </div>
      {approve && state?.approve?.find(x => x.field === 'consumerContact') && (
        <ThreeWaySwitch
          readOnly={readOnly}
          state={state}
          setState={setState}
          name={"consumerContact" as keyof IProduct}
        />
      )}
    </div>
  );
};

export default ConsumerContact;
